import React, { FC } from "react";
import { Typography } from "antd";

import { FormattedMessage } from "react-intl";
type TableTotalCountProps = {
  total: number;
};

const TableTotalCount: FC<TableTotalCountProps> = (props) => {
  const { Text } = Typography;
  const { total } = props;
  return (
    <Text strong>
      <FormattedMessage id="table.total" />
      {total}
    </Text>
  );
};

export default TableTotalCount;
